import { IChartData } from "../interfaces";
import { ITableData, PARAMETER_TYPE } from "../components/table/interfaces";

export const createEmptyAnalyticsResponse = (type: PARAMETER_TYPE): { chart: IChartData[]; table: ITableData } => {
  return {
    chart: [],
    table: {
      items: [],
      rows: [],
      type,
    },
  };
};
